import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@hero/constants';
import { contactServices } from '@hero/services';
import { cleanObjectEmptyFields, createQueryKey } from '@hero/utils';

export const useGetTagList = (params = {}, options = {}) => {
  const {
    filters: { searchTerm = '', ids = [] } = {},
    pagination: { page, limit } = {},
    options: { includeContacts = false, includeAutomations = false } = {}
  } = params;

  return useQuery(
    createQueryKey(QUERY_KEYS.useGetTagListKey, params),
    () =>
      contactServices.listTags(
        cleanObjectEmptyFields({
          filters: { searchTerm, ids },
          pagination: { page, limit },
          options: { includeContacts, includeAutomations }
        })
      ),
    options
  );
};
